
































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Shared types
import { System } from '@coldtec/cos-types';

// Store types
import { ToolSystem } from '@/store/store.types';

/**
 *  Component that renders the summary of a system -
 *  including the brand, product line and SKU - and
 *  reflecting his selected state.
 */
@Component
export default class SystemSummary extends Vue {

    @InjectReactive('system')
    private system!: System;

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

}
